import { isThinRoute } from "./seo-thin-policy.js";
/**
 * SEO indexability guardrails
 *
 * Policy (2026-06-12, Chantier 1 SEO noindex sweep):
 * Only private/utility routes are noindexed at the app layer. All
 * commercial pages — services, programmatic cities, industries,
 * comparisons, regional landings, BPO clusters — are indexable.
 *
 * Noindex remains enforced separately for:
 *  - query-stringed URLs (filters, pagination)   → SEOHead.tsx
 *  - Lovable preview subdomains                  → SEOHead.tsx
 *  - thin freelancer profiles (<200 words)       → FreelancerPublicProfilePage.tsx
 *  - explicit `noIndex` prop on a page           → SEOHead.tsx
 */

const LANGUAGE_SEGMENT_PATTERN = /^[a-z]{2}$/i;
const PRIVATE_UTILITY_ROUTE_PATTERN = /^(auth|admin|agent|portal|dashboard|account|settings|login|signup|sign-in|sign-up|forgot-password|reset-password|verify|checkout|cart|orders?|mail|client(?:\/|$)|invitations?)(\/|$)/;

export function extractSeoRoutePath(pathname: string): string {
  const segments = pathname.replace(/^\//, '').split('/').filter(Boolean);
  if (segments.length === 0) return '';
  return LANGUAGE_SEGMENT_PATTERN.test(segments[0])
    ? segments.slice(1).join('/')
    : segments.join('/');
}

export function isPrivateSeoRoute(routePath: string): boolean {
  if (!routePath) return false;
  return PRIVATE_UTILITY_ROUTE_PATTERN.test(routePath);
}

/**
 * SEO-1910b: templated city/country pages with no Google impression and no
 * priority market are noindex,follow. Policy lives once in seo-thin-policy.js,
 * shared with the sitemap scripts.
 */
export function isThinSeoPage(routePath: string): boolean {
  return isThinRoute(routePath);
}
